import { useEffect } from 'react';

import ContentStatusTag from '@/entities/content/ui/ContentStatusTag';
import contentStatuses, {
  type ContentStatus,
} from '@/shared/lib/constants/contentStatuses';
import { FilterState } from '@/shared/lib/filter/model/types';
import { Select } from '@/shared/ui/select';

export interface IContentStatusSelectProps {
  isSelectAll?: boolean;
  value: FilterState['contentStatuses'];
  onChange: (value: FilterState['contentStatuses']) => void;
  disabled?: boolean;
}

export default function ContentStatusSelect({
  isSelectAll,
  value: currentValue = [],
  onChange,
  disabled,
}: IContentStatusSelectProps) {
  const convertedCurrent = contentStatuses.filter(({ value }) =>
    currentValue.map((id) => +id).includes(value)
  );

  useEffect(() => {
    if (isSelectAll) {
      onChange(contentStatuses.map(({ value }) => value));
    }
  }, [isSelectAll, onChange]);

  return (
    <div className="min-w-[120px]">
      <Select
        type="multi"
        multiplyLabel="Statuses"
        options={contentStatuses.map(({ value, label }) => ({
          value,
          label,
          labelCaption: <ContentStatusTag contentStatusId={value} />,
        }))}
        current={convertedCurrent}
        onChange={(data) => {
          onChange(data.map(({ value }) => value) as ContentStatus[]);
        }}
        disabled={disabled}
      />
    </div>
  );
}
